import React from 'react';
import PropTypes from 'prop-types';

import TabToggle from '../../TabToggle/TabToggle';

import './AreaWorkforce.css';

const leftTab = 'Occupation Snapshot';
const rightTab = 'Industry Snapshot';

export class AreaWorkforceComponent extends React.Component {
  state = { tab: leftTab };

  render() {
    const { occupationUrl, industryUrl, onCancel } = this.props;
    const currentTab = this.state.tab.toLowerCase();

    return (
      <div className="area-workforce detail-content">
        <div className="back-to-overview">
          <a
            tabIndex="0"
            onClick={e => {
              e.preventDefault();
              onCancel();
            }}
          >
            &lt; Back to Overview
          </a>
        </div>

        <h2 className="section-group-title">
          <span>Workforce Data</span>
        </h2>

        <TabToggle
          name="workforceToggle"
          handleClick={tab => {
            this.setState({ tab });
          }}
          checked={currentTab === rightTab.toLowerCase()}
          leftTab={leftTab}
          rightTab={rightTab}
        />

        <div>
          <iframe
            src={currentTab === leftTab.toLowerCase()
              ? occupationUrl
              : industryUrl
            }
          />
        </div>
      </div>
    );
  }
}

AreaWorkforceComponent.propTypes = {
  occupationUrl: PropTypes.string,
  industryUrl: PropTypes.string,
  onCancel: PropTypes.func,
};

export default AreaWorkforceComponent;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaWorkforce/AreaWorkforce.js